import { useTranslation } from 'react-i18next'
import difference from 'lodash/difference'

import { KnowledgeBaseContentType } from 'types/KnowledgeBaseContentType'
import { Select, SelectProps } from 'components/inputs/Select/Select'
import * as Styled from './GroupSelect.styles'

interface GroupSelectProps extends SelectProps {
  className?: string,
  without?: KnowledgeBaseContentType[]
  label?: string
}

const GroupSelect: React.FC<GroupSelectProps> = ({
  className,
  without = [],
  label,
  ...rest
}) => {
  const { t } = useTranslation()

  const groupTypes = difference(Object.values(KnowledgeBaseContentType), without)

  return (
    <Select
      label={label ?? t('common.type')}
      className={className}
      {...rest}
    >
      {groupTypes.map((type) => (
        <Styled.MenuItem key={type} value={type}>
          {t(`group.${[type]}`)}
        </Styled.MenuItem>
      ))}
    </Select>
  )
}

export { GroupSelect }
